module.exports = __webpack_public_path__ + "img/singapore-expo.a554a359.jpg";